<script lang="ts">
import { Component } from 'vue-property-decorator'
import ClickableIconSmall from './ClickableIconSm.vue'

@Component({ name: 'ClickableIconLarge' })
export default class ClickableIconLarge extends ClickableIconSmall {
  fontSizeClass = 'is-size-1'
}
</script>
